import i18next from "i18next";

import { StateAbbreviationList } from "../constants/csv";
import { ROLE } from "../constants/role";
import { stateRights } from "../config/stateRights";
import { UserState } from "../redux/reducers/UserSlice";
import { useAppSelector } from "../redux/hooks";
import Cookies from "js-cookie";

declare global {
  interface Navigator {
    msSaveBlob: (blob: Blob, fileName: string) => boolean;
  }
}
export default class Utility {
  /**
   *
   * @param birthDate "yyyy-mm-dd"
   * @returns
   */
  public static getAge(birthDate: string): any {
    const translatedYear = i18next.t("years");
    const translatedMonth = i18next.t("months");
    const translatedDay = i18next.t("days");
    let calYear;
    let calMonth;
    let calDay;
    if (birthDate) {
      let nowDate: any = new Date(new Date().setHours(0, 0, 0, 0));

      let dobDate: any = new Date(birthDate);
      let years: number = nowDate.getFullYear() - dobDate.getFullYear();
      let months: number = nowDate.getMonth() - dobDate.getMonth();
      let days: any = nowDate.getDate() - dobDate.getDate(); // Work out the difference in months.
      months += years * 12;
      if (days < 0) {
        months -= 1;
      }
      // Now add those months to the date of birth.
      dobDate.setMonth(dobDate.getMonth() + months);
      // Calculate the difference in milliseconds.
      let diff = nowDate - dobDate;
      // Divide that by 86400 to get the number of days.
      days = Math.round(diff / 86400 / 1000);
      // Now convert months back to years and months.
      years = Number(months / 12);
      months -= years * 12;
      // Format age as "xx years, yy months, zz days"
      let text = "";
      if (years) {
        calYear = Math.floor(years);
        calMonth = Math.round((years - Math.floor(years)) * 12);
      }
      if (days) {
        if (text.length) {
          text = text + " ";
        }
        calDay = days;
      }
      if (calYear) {
        text = `${calYear} ${translatedYear}`;
        if (calMonth) {
          text = `${calYear} ${translatedYear}, ${calMonth} ${translatedMonth}`;
        }
      } else {
        if (calMonth) {
          text = `0 ${translatedYear}, ${calMonth} ${translatedMonth}`;
        } else {
          text = `0 ${translatedYear}, 0 ${translatedMonth}, ${days} ${translatedDay}`;
        }
      }
      //Same Day DOB Scenario
      if (!calYear && !calMonth && !calDay) {
        text = `0 ${translatedYear}, 0 ${translatedMonth}, 1 ${translatedDay}`;
      }
      return text;
    } else {
      return "NA";
    }
  }

  public static objectToQueryString(params: any) {
    //TODO: optimize this methos
    var queryString = Object.keys(params).map(key => {
      return key == "name"
        ? key + "=" + Utility.getSearchName(params[key])
        : key + "=" + params[key];
    });
    return `?${queryString
      .filter(function (el) {
        return el;
      })
      .join("&")}`;
  }

  public static patientName(nameObj: any) {
    let strName = "-";
    if (nameObj && nameObj[0]) {
      const firstName = nameObj[0].given ? nameObj[0]?.given[0] : "";
      const middleName = nameObj[0].given ? nameObj[0]?.given[1] : "";
      const lastName = nameObj[0].family || "";
      strName = firstName + ((middleName) ? " " + middleName : "") + " " + lastName;
      return strName;
    } else {
      return strName;
    }
  }

  public static patientMobileNumber(numberObj: any) {
    let strNumber = "";
    if (numberObj && numberObj[0]) {
      const mobileNumber = numberObj[0].value ? numberObj[0]?.value : "";
      return mobileNumber;
    } else {
      return strNumber;
    }
  }
  public static ageToDate(ageInYears: number) {
    const today = new Date();
    const month = today.getMonth() + 1;
    const actualMonth = month < 10 ? `0${month}` : month;
    const day = "01";
    const year = today.getFullYear() - ageInYears;
    return `${year}-${actualMonth}-${day}`;
  }

  public static get env(): any {
    if ((window as any)._env_ !== undefined) {
      return (window as any)._env_;
    }
    return process.env;
  }

  public static formatNumber(n: number): string {
    return n < 10 ? "0" + n : n.toString();
  }
  public static breakWord(after: number, key: string): string {
    const str = i18next.t(key) || "";
    let arr = str.split(" ");
    arr.splice(after, 0, "<br />");
    return arr.join(" ");
  }
  public static formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const month =
      date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const formattedDate = `${this.formatNumber(
      date.getDate()
    )}/${month}/${date.getFullYear()}`;
    return formattedDate;
  }

  public static sort(sortVal: any) {
    return sortVal.sort((sortValOne: any, sortValTwo: any) =>
      sortValOne.label > sortValTwo.label ? 1 : -1
    );
  }

  public static genderAbbreviation(gender: string) {
    const abbreviation =
      gender == "male" ? "M" : gender == "female" ? "F" : "O";
    return abbreviation;
  }

  public static getSearchName(search: any) {
    const patientName = search.split(" ");
    patientName[1] !== undefined &&
      (search = `${patientName[0]}&name=${patientName[1]}`);
    return search;
  }

  public static getIDString(patient: any) {
    const identifier = patient?.identifier?.[0]?.assigner?.display;
    const idName = identifier || "id";
    return idName;
  }

  public static getIDNumber(patient: any) {
    const idNumber =
      (patient?.identifier && patient?.identifier[0]?.value.toUpperCase()) ||
      "unavailable";
    return idNumber;
  }

  public static englishOnly = (e: any) => {
    e.target.value = e.target.value.replace(/[^0-9A-Za-z ]/gi, "");
  };

  public static englishOnlyWithSpecialCharacter = (e: any) => {
    e.target.value = /(\s\s)+/gi.test(e.target.value)
      ? e.target.value.trim()
      : /^[\s]+/.test(e.target.value)
      ? e.target.value.trim()
      : e.target.value.replace(/[^0-9A-Za-z\-\+ ]/gi, "");
  };

  public static englishOnlyWithSpecialCharacterForSearch = (e: any) => {
    return (e.target.value = /(\s\s)+/gi.test(e.target.value)
      ? e.target.value.replace(/(\s\s)+/gi, " ")
      : e.target.value.replace(/[^0-9A-Za-z\-\+ ]/gi, ""));
  };

  public static englishOnlyWithSpace = (e: any) => {
    e.target.value = /(\s\s)+/gi.test(e.target.value)
      ? e.target.value.replace(/(\s\s)+/gi, " ")
      : e.target.value.replace(/[^0-9A-Za-z ]/gi, "");
  };

  public static addressFieldEnglish = (e: any) => {
    e.target.value = /(\s\s)+/gi.test(e.target.value)
      ? e.target.value.replace(/(\s\s)+/gi, " ")
      : /^[\s]+/.test(e.target.value)
      ? e.target.value.trim()
      : e.target.value.replace(/[^0-9A-Za-z\d.,\/\- ]/gi, "");
  };

  public static englishOnlyWitoutSpace = (e: any) => {
    e.target.value = e.target.value.replace(/[^0-9A-Za-z]/gi, "");
  };

  public static convertPhoneNumber = (number: any) => {
    if (number.includes("+91")) {
      return number.substring(3);
    }
    return number;
  };

  public static addCountryCode = (number: any) => {
    let code = "+91";
    if (!number.toString().includes("+91")) {
      return `${code}` + number;
    }
    return number;
  };

  public static userNameConvert(userName: string) {
    if (StateAbbreviationList.indexOf(userName.substring(0, 2)) > -1) {
      return userName.substring(3);
    }
    return userName;
  }

  public static convertToCSV(objArray: any, headers: any) {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in headers) {
        // line += ','

        if (!array[i][index]) {
          line += " " + ",";
        } else {
          line += array[i][index] + ",";
        }
      }

      str += line + "\r\n";
    }
    return str;
  }

  public static exportCSVFile(headers: any, items: any, fileTitle: any) {
    if (headers) {
      items.unshift(headers);
    }

    const jsonObject = JSON.stringify(items);

    const csv = this.convertToCSV(jsonObject, headers);

    const exportedFilenmae = fileTitle + ".csv" || "export.csv";

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator?.msSaveBlob) {
      // IE 10+
      navigator?.msSaveBlob(blob, exportedFilenmae);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  public static getStatusValue(
    statusValue: any,
    app_metaData: any,
    blockerFor: any
  ) {
    const blocked = statusValue === true ? true : false;
    const registeredStatus = app_metaData?.registered === true ? true : false;
    if (blockerFor?.length > 0) {
      let currentStatus = "Disabled";
      if (registeredStatus && !blocked) {
        currentStatus = "Disabled";
      } else if (registeredStatus && blocked) {
        currentStatus = "Inactive";
      } else if (!registeredStatus && !blocked) {
        currentStatus = "Not activated";
      } else if (!registeredStatus && blocked) {
        currentStatus = "Not activated";
      }
      return currentStatus;
    } else if (registeredStatus && !blocked) {
      return "Active";
    } else {
      if (!registeredStatus && blocked) {
        return "Not activated";
      } else if (!registeredStatus && !blocked) {
        return "Not activated";
      } else if (registeredStatus && blocked) {
        return "Inactive";
      }
    }
  }
  // Method to Check if user has Left Either of DD,MM & YYYY Empty while Editing Date
  public static isDdMmYyyyEmpty() {
    const year = this.getNodeValue("year");
    const month = this.getNodeValue("month");
    const day = this.getNodeValue("day");
    if (!year || !month || !day) {
      return true;
    }
    return false;
  }

  public static getNodeValue(className: String) {
    const commonClassName =
      "react-date-picker__inputGroup__input react-date-picker__inputGroup__";
    const arr = document.getElementsByClassName(
      `${commonClassName}${className}`
    ) as HTMLCollection;
    if (arr?.length) {
      return (arr[0] as HTMLInputElement)?.value;
    } else {
      return "Temp Placeholder"; //Code to Handle in case Class Names Have been Changed
    }
  }

  public static inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  public static getUserRole = (roles: string) => {
    let role = "";
    switch (roles?.toLowerCase()) {
      case "anm":
        role = ROLE.ANM;
        break;
      case "asha":
      case "screen-patients":
        role = ROLE.ASHA;
        break;
      case "global admin":
        role = ROLE.GLOBAL_ADMIN;
        break;
      case "state admin":
        role = ROLE.ADMIN;
        break;
      case "global admin support":
        role = ROLE.GLOBAL_ADMIN_SUPPORT;
        break;
      default:
    }
    return role;
  };
  //config for State specific Id Types
  public static getIdTypesForState(stateName: any) {
    return stateRights[stateName]?.idOptions;
  }

  // Method to create dynamic placeholder as per ID types
  public static getPlaceholderForState(stateName: any, userCountry: any) {
    const countryConfigurations = this.getUserCountryConfig(userCountry);
    const dynamicPlaceholderStr: any = (
      stateRights[stateName]?.idOptions ||
      countryConfigurations?.available_identifiers
    )
      .map((id: any) => {
        return i18next.t(id.label);
      })
      .join("/ ");
    const dynamicPlaceholder = dynamicPlaceholderStr
      ? `${i18next.t("EnEnter")} ${dynamicPlaceholderStr} ${i18next.t(
          "HiEnter"
        )}`
      : undefined;
    return dynamicPlaceholder;
  }

  //Utility method to get State of User
  public static getStateOfUser() {
    const userDetails: any = useAppSelector(UserState);
    return userDetails?.userDetails?.user_metadata?.address?.region
      ?.toLowerCase()
      .replace(/ /g, "");
  }

  public static getOptions(options: any) {
    let newOptions = [];
    for (let i of options) {
      // let tempLabel = i18next.t(i.label);
      // //console.log(tempLabel);
      // let tempValue = i.value;
      newOptions.push({
        label: i18next.t(i.label),
        value: i.value,
      });
    }
    return newOptions;
  }

  public static getTranslatedBlankOption(text: any) {
    return i18next.t(text);
  }

  public static uniqueListToQueryString(
    uniquenessArray: any,
    basicDetailsObj: any
  ) {
    let finalString = "";
    for (let i = 0; i < uniquenessArray.length; i++) {
      finalString += `${uniquenessArray[i].crdKey}=${basicDetailsObj[
        uniquenessArray[i].patientSchemaKey
      ]
        ?.toString()
        ?.toLowerCase()
        ?.toString()
        ?.trim()}&`;
    }
    return `?${finalString}_total=accurate`;
  }
  //Utility method to set dynamic style to <ul></ul>
  public static setStylesUL(totalLength: any) {
    let gridRows =
      totalLength > 0 && totalLength <= 25 ? totalLength / 2 : totalLength / 4;

    return {
      display: "grid",
      gridTemplateRows: `repeat(${gridRows.toFixed()}, min-content)`,
      gridAutoFlow: "column",
      marginTop: "12px",
      gridRowGap: "8px",
    };
  }

  // Utility method to fetch the country specific configurations based on the App URL
  public static getUserCountryConfig(country: string) {
    let userCountry = country || "in";
    const countryConfigurations = require("../config/countryConfig/countryRights_v1.json");
    if (!countryConfigurations.config[userCountry]) {
      userCountry = "in";
    }
    const userCountryConfig = countryConfigurations?.config[userCountry];
    return userCountryConfig;
  }

  public static getValidIdentifierOptions = (
    id_options: any,
    userCountry: any
  ) => {
    const countryConfigurations = this.getUserCountryConfig(userCountry);
    const countryIdentifiers = countryConfigurations?.available_identifiers.map(
      (identifier: any) => {
        return identifier.value;
      }
    );
    let stateOptions = this.getOptions(id_options);
    let validOptions = stateOptions.filter(options => {
      return countryIdentifiers.includes(options.value);
    });
    return validOptions;
  };

  public static getCookie = (name: string) => {
    const cookie_data = Cookies.get(name);
    return cookie_data;
  };

  /**
   * This function will divide a large array into smaller pieces of arrays to be used as a grid
   * @param list is the array which needs to be divided into chunks of equal items
   * @param size is the number of chunks to be created from the provided array, default is set to 4
   * @param minimum is the smallest number of items each chunk should have, default is set to 6
   * @returns array with small arrays having equal number of items from the list
   */
  public static createChunkSet = (
    list: any,
    size: number = 4,
    minimum: number = 6
  ) => {
    let chunkSet: any = new Array();
    if (typeof list !== "object") {
      // If the value is not an array, it will be converted into a single value array
      chunkSet.push([list]);
    } else {
      let splitSize = Math.ceil(list.length / size);
      splitSize = splitSize < minimum ? minimum : splitSize;
      console.log("splitSize", splitSize);
      let initial: number = 1;
      let chunk: any = [];
      list.forEach((item: Array<any>, i: number) => {
        chunk.push(item);
        if (initial === splitSize || i === list.length - 1) {
          chunkSet.push(chunk);
          chunk = [];
          initial = 1;
        } else {
          initial++;
        }
      });
    }
    return chunkSet;
  };

  /**
   * check if the beneficiary is minor
   * @param dob string
   * @returns boolean
   */
  public static isMinor = (dob: string) => {
    if (dob === undefined || dob === null || dob === "") return false;
    const dt = dob.split("/");
    const age = Utility.getAge(`${dt[2]}-${dt[1]}-${dt[0]}`);
    return parseInt(age) < 18 ? true : false;
  };
}
